import { render, staticRenderFns } from "./openService.vue?vue&type=template&id=4b1ab786&"
import script from "./openService.vue?vue&type=script&lang=js&"
export * from "./openService.vue?vue&type=script&lang=js&"
import style0 from "./openService.vue?vue&type=style&index=0&id=4b1ab786&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports